import { render, staticRenderFns } from "./Register_2026.vue?vue&type=template&id=72137493&scoped=true&"
import script from "./Register_2026.vue?vue&type=script&lang=js&"
export * from "./Register_2026.vue?vue&type=script&lang=js&"
import style0 from "./Register_2026.vue?vue&type=style&index=0&id=72137493&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72137493",
  null
  
)

export default component.exports